import { render, staticRenderFns } from "./MultiHistoryTable.vue?vue&type=template&id=cd8f400a&scoped=true&"
import script from "./MultiHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MultiHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MultiHistoryTable.vue?vue&type=style&index=0&id=cd8f400a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f400a",
  null
  
)

export default component.exports